import { createFileRoute, notFound, stripSearchParams } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { ServiceJobDataPage } from "@/components/ServiceJob/ServiceJobDataPage";
import { dataTableSearchSchema, DEFAULT_DATATABLE_OPTIONS } from "@/configs/datatable";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/service-jobs/planner/")({
  validateSearch: dataTableSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_DATATABLE_OPTIONS)],
  },
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.service-jobs-planner"),
        icon: <Icon.SERVICE_JOBS />,
        path: "/workspaces/$workspace_id/service-jobs",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
  },
  component: ServiceJobDataPage,
});
